import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';

const Industry = () => {
  return (
    <div className="about-mijsc-section w-full bg-cover h-fit pb-10">
      <Helmet>
        <title>Industry</title>
        <meta
          name="description"
          content="Learn more about MIJSC, our mission, vision, and commitment to excellence."
        />
      </Helmet>

      <BreadCrumbs />

      <div className="w-[94%] mx-auto text-justify">
        <section className="w-full space-y-20 mt-10">

          {/* Mizuho Bank */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="md:text-4xl text-lg text-green-600 font-semibold mb-4">
                Mizuho Bank
              </h2>
              <p className="text-gray-600 text-sm sm:text-base">
                Mizuho Bank, which is among the top 20 banks in the world, and among top three banks in Japan, with total assets of approximately $1.89 trillion, is supporting Mizuho India Japan Study Centre through its’ CSR funding.
              </p>
            </div>

            <div
              className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700 md:ml-[45px]"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/imgs/partners-mizuho-bank.jpg)`
              }}
            />
          </div>

          {/* BPL */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div
              className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700 md:order-1 order-2 md:-ml-[60px]"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/imgs/partners-bpl-medical-technology.jpg)`
              }}
            />

            <div className="md:order-2 order-1">
              <h2 className="md:text-4xl text-lg text-green-600 font-semibold mb-4">
                BPL
              </h2>
              <p className="text-gray-600 text-sm sm:text-base">
                MIJSC has received continuous and invaluable support from BPL Medical Technologies, a leader in the field of medical technologies, through their CSR funding.</p>
              <p className="text-gray-600 text-sm sm:text-base mt-2">In partnership with BPL Medical Technologies, MIJSC is also working on a groundbreaking initiative aimed at transforming engineering faculty into industry consultants. This program, delivered through a 6-module course, is designed to bridge the gap between academia and industry. It will also be available on the MOOCs platform, ensuring wide access and scalability.
              </p>
            </div>
          </div>

          {/* Toshiba */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="md:text-4xl text-lg text-green-600 font-semibold mb-4">
                Toshiba
              </h2>
              <p className="text-gray-600 text-sm sm:text-base">
                Toshiba Software India Pvt. Ltd. (TSIP) Bangalore is an integral part of Toshiba Corporation, Japan. The Toshiba Corporation is a heterogeneous manufacturer and marketer of advanced electronic and electrical products, spanning information and communication equipment and systems, Internet-based solutions and services, electronic components and materials, power systems, industrial and social infrastructure systems, and household appliances.
              </p>
            </div>

            <div
              className="rounded-xl w-full h-64 bg-cover bg-center transition-all duration-700 md:ml-[45px]"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/assets/imgs/partner-toshiba-software-company.jpg)`
              }}
            />
          </div>

        </section>
      </div>
    </div>
  );
};

export default Industry;
